import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import model from './model';
import selectors from './selectors';
/**
 * Utility class to fetch draft applications from a REST API.
 */

var utils = function utils() {
  _classCallCheck(this, utils);
};

_defineProperty(utils, "resource", 'v1/ua/draft_applications');

_defineProperty(utils, "fetchDraftApplications", function (callback) {
  ReduxUtils.getSortedParsedDataFromRestAPI(callback, utils.resource, model, selectors.sortedByDateSelector);
});

export { utils as default };